module.exports = __webpack_public_path__ + "static/media/logo-visiperf.8b2ae2dd.png";